import React from 'react';

import FooterComponent from './components/FooterComponent';
import HeaderComponent from './components/HeaderComponent';
import ResetPasswordForm from './components/forms/ResetPasswordForm';

const ResetPassword = () => {
    return (
        <>
            <HeaderComponent />
            <div className="flex">
                <div className="h-screen w-1/2 border border-red-500 bg-gray-200">
                    Left section
                </div>
                <ResetPasswordForm />
            </div>
            <FooterComponent />
        </>
    );
};

export default ResetPassword;
